<template>
  <section v-if="isFetchingContacts">
    <spinner-loader :loading="isFetchingContacts" />
  </section>

  <!-- Error -->
  <section v-else-if="errored">
    <p>An error occurred.</p>
  </section>

  <!-- No Contacts Yet -->
  <section v-else-if="contacts.length < 1">
    <br />
    <br />
    <br />
    <p>
      You don't have any guest profiles yet. <br />Create your first one by
      clicking "New Guest."
    </p>
    <b-button @click="handleShowAddContactModal" style="margin-top: 4px">
      {{ $t("contacts.add_contact") }}
    </b-button>
    <contact-modal ref="addContactModal" class="contact-modal-btn-new">
      <template slot="submit">
        <b-button @click="handleAddContact">Save</b-button>
      </template>
    </contact-modal>
  </section>

  <!-- Contacts  -->
  <section v-else class="content-container">
    <div>
      <b-row class="search-header" align-h="center">
        <contact-modal ref="addContactModal" class="contact-modal-btn-new">
          <template slot="submit">
            <b-button @click="handleAddContact">Save</b-button>
          </template>
        </contact-modal>
        <b-col md="6" class="my-1">
          <b-input-group>
            <b-form-input v-model="filter" :placeholder="$t('search')" />
          </b-input-group>
        </b-col>
        <b-col md="2">
          <b-button @click="handleShowAddContactModal" style="margin-top: 4px">
            {{ $t("contacts.add_contact") }}
          </b-button>
        </b-col>
      </b-row>
    </div>
    <b-table
      v-if="!isLoading"
      :items="contacts"
      :fields="fields"
      :filter="filter"
      :hover="hover.show"
      striped
      @row-clicked="rowClicked"
      class="contacts-table"
      fixed
    >
      <template slot="cell(name)" slot-scope="row">
        <h5>{{ row.item.name }}</h5>
      </template>
    </b-table>

    <!-- Loading Screen -->
    <div v-else class="fixed-center loadingSpace">
      <b-modal
        :visible="isLoading"
        content-class="fetching-spinner-content"
        centered
        hide-header
        hide-footer
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
      >
        <div slot="default">
          <div class="loading-message">
            <p>{{ $t("loading_contacts") }}</p>
          </div>
          <spinner-loader />
        </div>
      </b-modal>
    </div>

    <contact-modal ref="editContactModal" class="contact-modal-btn-new">
      <template slot="submit">
        <b-button @click="handleUpdateContact">Update</b-button>
      </template>
    </contact-modal>
  </section>
</template>

<script>
import SpinnerLoader from "@/components/widgets/SpinnerLoader";
import { mapGetters, mapState } from "vuex";
import ContactModal from "../../components/modals/ContactModal";
import _ from "lodash";

export default {
  name: "contacts.contacts",
  mounted() {
    this.isLoading = true;
    this.contacts = _.cloneDeep(this.$store.getters.getContacts);

    this.isLoading = false;
  },
  watch: {
    getContacts: {
      handler(newValue, oldValue) {
        this.contacts = newValue;
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      errored: (state) => state.contacts.errored,
      isFetchingContacts: (state) => state.contacts.isFetchingContacts,
    }),
    ...mapGetters(["getContacts"]),
    fields() {
      return [
        {
          key: "first_name",
          label: this.$t("first_name").toUpperCase(),
          sortable: true,
          thStyle: "border-top:none;",
        },
        {
          key: "last_name",
          label: this.$t("last_name").toUpperCase(),
          sortable: true,
          thStyle: "border-top:none;",
        },
        {
          key: "email",
          label: this.$t("email").toUpperCase(),
          sortable: true,
          thStyle: "border-top:none;",
          thClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
        },
        {
          key: "phone",
          label: this.$t("phone").toUpperCase(),
          sortable: true,
          thStyle: "border-top:none;",
          thClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
        },
        {
          key: "country_of_origin",
          label: this.$t("country").toUpperCase(),
          sortable: true,
          thStyle: "border-top:none;",
        },
        {
          key: "instagram",
          label: this.$t("instagram").toUpperCase(),
          sortable: true,
          thStyle: "border-top:none;",
          thClass: "d-none d-md-table-cell",
          tdClass: "d-none d-md-table-cell",
        },
      ];
    },
  },
  data() {
    return {
      filter: "",
      isLoading: "",
      contacts: [
        {
          first_name: "",
          middle_name: "",
          last_name: "",
          photo_uri: "",
          birthday: "",
          country_of_origin: "",
          citizenship: "",
          sex: "",
          email: "",
          phone: "",
          address: "",
          facebook: "",
          instagram: "",
          twitter: "",
          snapchat: "",
          pinterest: "",
          company: "",
          title: "",
        },
      ],
      pages: 0,
      hover: {
        show: true,
        photo: true,
      },
    };
  },
  components: {
    SpinnerLoader,
    ContactModal,
  },
  methods: {
    rowClicked(_record, _index) {
      // copy the clicked object to prevent modifying vuex state and vuex warning.
      const recordCopy = Object.assign({}, _record);
      this.$refs.editContactModal.show(recordCopy);
    },
    handleShowAddContactModal() {
      this.$refs.addContactModal.show();
    },
    handleAddContact() {
      this.$refs.addContactModal.addContact();
      this.$refs.addContactModal.clearData();
      this.$refs.addContactModal.hide();
    },
    handleUpdateContact() {
      this.$refs.editContactModal.updateContact();
      this.$refs.editContactModal.hide();
    },
  },
};
</script>

<style>
.search-header {
  background: #f7f7f7;
  padding: 10px 0px 10px 0px;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  margin: 0px;
}
th {
  border-top: none;
  background: #f7f7f7;
  outline: none !important;
}
.contact-modal-btn-new {
  position: absolute;
  right: 12px;
  top: 28px;
}
.contacts-table td {
  padding: 6px 20px 6px 20px;
  overflow: hidden;
  text-align: center;
}
.contacts-table {
  background: white;
}
.contacts-table th {
  border-top: none;
  outline: none !important;
}
.loading-message {
  position: relative;
  top: -70px;
  color: #fcfcfc;
}
.fetching-spinner-content {
  background: transparent !important;
  border: none !important;
}
.loadingSpace {
  left: 54px;
  top: 54px;
  width: 100%;
  height: 100%;
  background-color: grey;
}
</style>
